import loadable from '@loadable/component'

export const SurveillanceReportList = loadable(
  () => import('./SurveillanceReportList')
)
export type { SurveillanceItemProps } from './SurveillanceReportList'
export * from './__mocks__/Surveillance.mock'
